module.exports = __webpack_public_path__ + "img/hkstp.806c09e4.png";